import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const Homepage = styled('span', {
  shouldForwardProp: (prop) => prop !== 'homepage',
})`
  @media screen and (min-width: 992px) {
    ${({ homepage }) => (homepage ? 'text-transform: uppercase;' : '')}
    ${({ homepage }) => (homepage ? 'font-size: 68px;' : 'font-size: 50px;')}
    ${({ homepage }) =>
      homepage ? 'line-height: 70px;' : 'line-height: 54px;'}
    ${({ homepage }) => (homepage ? 'font-weight: 700;' : 'font-weight: 500;')}
  }
  @media screen and (max-width: 991px) {
    ${({ homepage }) => (homepage ? 'text-transform: uppercase;' : '')}
    ${({ homepage }) => (homepage ? 'font-size: 42px;' : 'font-size: 34px;')}
    ${({ homepage }) =>
      homepage ? 'line-height: 46.2px;' : 'line-height: 34.5px;'}
    ${({ homepage }) => (homepage ? 'font-weight: 500;' : 'font-weight: 700;')}
  }
`;

const Heading1 = (props) => {
  const homepage = Boolean(props.homepage);

  const {
    color,
    children,
    underline: _underline,
    uppercase: _uppercase,
    ...rest
  } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <Typography
      {...rest}
      component="h1"
      color={typographyColor}
      sx={[colorStyle, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}
    >
      <Homepage homepage={homepage}>{formattedChildren}</Homepage>
    </Typography>
  );
};

export default Heading1;
